import { render, staticRenderFns } from "./ManualTeacherPdf.vue?vue&type=template&id=33391d76&lang=pug&"
import script from "./ManualTeacherPdf.vue?vue&type=script&lang=ts&"
export * from "./ManualTeacherPdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports